// Human-readable duration from minutes: "4 min", "11.0 h", "3.9 days"
export default function formatDuration (minutes) {
  if (minutes === null || minutes === undefined) return 'No data'
  if (minutes < 60) return `${Math.round(minutes)} min`
  if (minutes < 48 * 60) return `${(minutes / 60).toFixed(1)} h`
  return `${(minutes / 1440).toFixed(1)} days`
}
